import React, { useEffect, useRef, useState } from "react";
import { getBaseUrl } from "../../../../../Redux/Config/AppConfig";
import { useDispatch, useSelector } from "react-redux";
import {
  POST_RESTAURANT_VARIANT_REQUEST,
  PUT_RESTAURANT_VARIANT_REQUEST,
} from "../../../../../Utils/Constant";
import { useParams } from "react-router-dom";

const AddRestaurantVariant = ({ selectedVariant, setSelectedVariant }) => {
  const BaseUrl = getBaseUrl();
  const closeBtnRef = useRef(null);
  const dispatch = useDispatch();
  const paramDataa = useParams();
  const CategoryId = paramDataa?.categoryId;
  const SubCategoryId = paramDataa?.subCategoryId;
  //    const { addCategory } = useSelector((state) => state.restaurant);

  const [formData, setFormData] = useState({
    name: "",
    flavor: "",
    size: "",
    // quantity: "",
    price: "",
  });

  const [errors, setErrors] = useState({});
  useEffect(() => {
    if (selectedVariant) {
      setFormData({
        name: selectedVariant.name || "",
        flavor: selectedVariant.flavor || "",
        size: selectedVariant.size || "",
        // quantity: selectedVariant.quantity || "",
        price: selectedVariant.price || "",
      });
    } else {
      setFormData({ name: "", size: "" , flavor:"", price:""});
    }
    setErrors({});
  }, [selectedVariant]);

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Variant name is required.";
    if (!formData?.price && !parseFloat(formData.price))
      newErrors.price = "Valid price is required.";
    // if (!formData.size.trim()) newErrors.size = "Size is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    if (selectedVariant) {
      dispatch({
        type: PUT_RESTAURANT_VARIANT_REQUEST,
        payload: { id: selectedVariant?.id, body: formData },
      });
    } else {
      const addVariantPayload = {...formData,category_id:CategoryId,subcategory_id:SubCategoryId}
      dispatch({
        type: POST_RESTAURANT_VARIANT_REQUEST,
        payload: { body: addVariantPayload },
      });
    }
    setFormData({ name: "", size: "", flavor: "", price: "" });
    setErrors({});
    closeBtnRef.current?.click();
  };

  const handleClear = () => {
    setFormData({
      name: "",
      size: "",
      flavor: "",
      // quantity: "",
      price: "",
    });
    setErrors({});
  };

  return (
    <div
      className="offcanvas offcanvas-end"
      tabIndex="-1"
      id="add-varient"
      aria-labelledby="add-varient"
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title">
          {selectedVariant ? "Edit Variant" : "Add Variant"}
        </h5>
        <button
          ref={closeBtnRef}
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={() => setErrors({})}
        ></button>
      </div>
      <div className="offcanvas-body">
        <div className="form-group mb-3">
          <label className="form-label text-muted">
            Variant Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            name="name"
            className={`form-control ${errors.name ? "is-invalid" : ""}`}
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter variant name"
          />
          {errors.name && <div className="invalid-feedback">{errors.name}</div>}
        </div>

        <div className="form-group mb-3">
          <label className="form-label text-muted">Flavor</label>
          <input
            type="text"
            name="flavor"
            className={`form-control ${errors.flavor ? "is-invalid" : ""}`}
            value={formData.flavor}
            onChange={handleChange}
            placeholder="Enter flavor (optional)"
          />
          {errors.flavor && (
            <div className="invalid-feedback">{errors.flavor}</div>
          )}
        </div>

        <div className="form-group mb-3">
          <label className="form-label text-muted">
            Size
          </label>
          <input
            type="text"
            name="size"
            className={`form-control ${errors.size ? "is-invalid" : ""}`}
            value={formData.size}
            onChange={handleChange}
            placeholder="Enter size (e.g., Small, Medium, Large)"
          />
          {errors.size && <div className="invalid-feedback">{errors.size}</div>}
        </div>

        <div className="form-group mb-3">
          <label className="form-label text-muted">
            Price <span className="text-danger">*</span>
          </label>
          <input
            type="number"
            step="1"
            name="price"
            className={`form-control ${errors.price ? "is-invalid" : ""}`}
            value={formData.price}
            onChange={handleChange}
            placeholder="Enter price"
          />
          {errors.price && (
            <div className="invalid-feedback">{errors.price}</div>
          )}
        </div>

        {/* <div className="form-group mb-3">
          <label className="form-label text-muted">
            Quantity <span className="text-danger">*</span>
          </label>
          <input
            type="number"
            name="quantity"
            className={`form-control ${errors.quantity ? "is-invalid" : ""}`}
            value={formData.quantity}
            onChange={handleChange}
            placeholder="Enter available quantity"
          />
          {errors.quantity && (
            <div className="invalid-feedback">{errors.quantity}</div>
          )}
        </div> */}

        <div className="d-flex">
          <button
            type="button"
            className="btn w-100 me-1 py-2 btn-primary"
            onClick={handleClear}
          >
            Clear
          </button>
          <button
            type="button"
            className="btn w-100 ms-1 py-2 btn-dark"
            onClick={handleSubmit}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddRestaurantVariant;
